import { Injectable } from '@angular/core';
import { RequestService } from '@df/api/request/request.service';
import { GooglePay } from '@df/module-google-pay/google-pay.namespace';

@Injectable({ providedIn: 'root' })
export class GooglePayService {
    constructor(private requestService: RequestService) {}

    load(): Promise<HTMLScriptElement> {
        return this.requestService.loadScriptAsync(GooglePay.Scripts.pay);
    }

    getGooglePayPaymentsClientConstructable(): GooglePay.IApiPaymentsClientConstructable | undefined {
        return window.google?.payments?.api?.PaymentsClient;
    }

    getPaymentsClientInstance(options: GooglePay.IPaymentOptions): GooglePay.IPaymentsClientInstance | undefined {
        const clientContructor = this.getGooglePayPaymentsClientConstructable();
        if (clientContructor) {
            return new clientContructor(options);
        }
        return undefined;
    }
}
